import React, { forwardRef } from "react";
import DatePicker from "react-datepicker";
import { Form } from "react-bootstrap";

function ymToFirstDay(ym) {
    if (typeof ym !== "string" || !/^\d{4}-\d{2}$/.test(ym)) {
        const d = new Date();
        return new Date(d.getFullYear(), d.getMonth(), 1);
    }
    const y = parseInt(ym.slice(0, 4), 10);
    const mo = parseInt(ym.slice(5, 7), 10) - 1;
    return new Date(y, mo, 1);
}

function dateToYm(d) {
    if (!d || Number.isNaN(d.getTime())) return "";
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    return `${y}-${m}`;
}

const MonthPickerInput = forwardRef(function MonthPickerInput(
    { value, onClick, onChange, size, disabled, className, ...rest },
    ref
) {
    return (
        <Form.Control
            ref={ref}
            value={value}
            onClick={onClick}
            onChange={onChange}
            size={size}
            disabled={disabled}
            className={className}
            autoComplete="off"
            {...rest}
        />
    );
});

/**
 * Місяць у форматі YYYY-MM, українська локаль react-datepicker (як на сторінці зарплат).
 */
export function AppMonthField({
    value,
    onChange,
    size,
    disabled,
    className,
    popperClassName,
    ...rest
}) {
    return (
        <DatePicker
            locale="uk"
            dateFormat="LLLL yyyy"
            showMonthYearPicker
            selected={ymToFirstDay(value)}
            onChange={(date) => {
                if (!date) return;
                onChange(dateToYm(date));
            }}
            customInput={<MonthPickerInput size={size} disabled={disabled} className={className} />}
            popperClassName={popperClassName}
            {...rest}
        />
    );
}
